// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aVEK","footer":"styles_footer__1JZZb","passCodeTooltip":"styles_passCodeTooltip__2KUio"};